import './Footer.css'

const Footer = () => (
  <footer className='footer'>
    <a
      href='https://github.com/elymeraj'
      className='link footer__link'
    >
      Eldis Ymeraj / eldisymeraj0@gmail.com / +33 7 83 88 39 26
    </a>
  </footer>
)

export default Footer
